<template>
  <div>
    <v-icon title="Help" small class="blue--text" @click="showHelper">fas fa-question-circle</v-icon>
    <v-navigation-drawer
      temporary
      v-model="helpDrawer"
      right
      width="700"
      hide-overlay
      fixed
      app
      left
      :clipped="$vuetify.breakpoint.lgAndUp"
    >
      <v-card v-if="helpDrawer">
        <v-card-title class="body-1">
          <strong>Articles</strong>&nbsp;
          <v-icon color=" blue" small>fas fa-clipboard-list</v-icon>
          <v-spacer />
          <v-spacer />
          <v-icon title="Close" small flat @click="helpDrawer = false">fa fa-times</v-icon>
        </v-card-title>
        <v-card-text class="caption text-xs-left pa-3">
          <template v-for="article in articles">
            <v-hover>
              <v-layout
                row
                wrap
                class="pa-2"
                slot-scope="{ hover }"
                :class="`${hover ? 'blue lighten-4' : 'white'}`"
              >
                <v-flex xs12>
                  <v-icon small class="purple--text">fas fa-square</v-icon>&nbsp;
                  <span class="grey--text text--darken-4 text-xs-left subheading body-2">
                    <b>
                      <strong>{{article.article_name}}</strong>
                    </b>
                  </span>
                  <span style="float:right">
                    <v-icon
                      small
                      @click="viewItem(article.id)"
                      class="grey--text text-xs-right"
                    >fas fa-eye</v-icon>
                  </span>
                  <br />
                  <span class="grey--text caption pl-4">
                    <small>{{article.author_name}} |</small>
                    <small>{{article.created ? moment(article.created).format('MM-DD-YYYY') : " "}}</small>
                    <small>{{article.category_name}}</small> |
                    <small>{{article.sub_category_name}}</small> |
                    <small>Revision # {{article.revisions ? article.revisions : 0 }}</small>
                    <v-chip class="grey white--text" small v-if="article.check_out">Checkout</v-chip>
                  </span>
                </v-flex>
              </v-layout>
            </v-hover>
          </template>
        </v-card-text>
      </v-card>
    </v-navigation-drawer>
    <v-dialog
      v-model="entryModal"
      hide-overlay
      transition="dialog-bottom-transition"
      fullscreen
      scrollable
    >
      <v-card>
        <ArticleView v-if="editFlag" :parameters="editData" v-on:closeDialog="closeDialog1" />
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
//import ArticlesModel from "@/api/service/ArticleService";
//import ArticleView from "@/views/articles/template/view.vue";
import moment from "moment";
export default {
  props: ["kbCategoryCode", "kbArticleId"],
  components: {
    //ArticleView
  },
  data() {
    return {
      articles: [],
      helpDrawer: false,
      editFlag: false,
      entryModal: false,
      editData: 0
    };
  },
  created: function() {
    this.getArticles();
  },
  mounted: function() {},
  computed: {},
  methods: {
    moment,
    getArticles() {
      var $Id = this.kbArticleId;
      let $condn = {};
      if (this.kbArticleId) {
        $condn = { id: this.kbArticleId };
      } else {
        $condn = { category_code: this.kbCategoryCode };
      }
      ArticlesModel.findAll($condn)
        .then(response => {
          this.setArticle(response);
        })
        .catch(error => {
          console.log(error);
        });
    },
    setArticle($article) {
      this.articles = $article;
    },
    showHelper() {
      this.helpDrawer = true;
    },
    viewItem($id) {
      this.entryModal = true;
      this.editFlag = true;
      this.editData = $id;
    },
    closeDialog1() {
      this.entryModal = false;
      this.editFlag = false;
    }
  }
};
</script>   
<style >
.custom_overlay {
  position: fixed;
  height: 100vh;
  width: 100%;
  background: rgba(50, 50, 50, 0.5);
  z-index: 2;
}
</style>